import { map } from "lodash";
import React from "react";
import { Errors } from "../../../@types";

export default function InviteErrors({ message, errors }: Errors) {
  return (
    message && (
      <div className="alert alert-danger">
        {message}
        {errors && (
          <ul>
            {map(errors, (error) => (
              <li>{error}</li>
            ))}
          </ul>
        )}
      </div>
    )
  );
}
